$.fn.extend
  objectEvents: (options) ->
    settings = 
      parent: false
      drop: false
    
    settings = $.extend settings, options

    object = $(@)
    frame = options.parent

    # console.log object

    bleed_container = frame.find('.bleed_container')

    dragged = false
    resized = false

    app_math = () ->

      dfd = new $.Deferred()
      $.ajax(   
        dataType: 'JSON'
        method: 'POST'
        data:
          parent_width: frame.width()
          parent_height: frame.height()
          frame_width: frame.data 'frame_width'
          frame_height: frame.data 'frame_height'
          frame_bleed: frame.data 'bleed'
          zoom: object.data 'zoom'
          image_src: object.find('img').attr 'src'
          bleed_pct: frame.data 'bleed_pct'
          bleed_val: frame.data 'bleed_val'
          white_stripes: frame.data 'white_stripes'

        url: '/ajax/app/app_math/'
      ).done( (data, textStatus, jqXHR) ->
        # console.log data
        dfd.resolve(data, textStatus, jqXHR)
        return
      ).fail (jqXHR, textStatus) ->
        dfd.reject(jqXHR)
        return

      return dfd.promise()

    resetData = (reload) ->

        app_math().done((data) ->
            # console.table data
            object.css
              left: data.result.rel.x + "%"
              top: data.result.rel.y + "%"
              width: data.result.rel.width + "%"
              height: data.result.rel.height + "%"

            object.data 'x', data.result.rel.x
            object.data 'y', data.result.rel.y
            object.data 'width', data.result.rel.width
            object.data 'height', data.result.rel.height

            saveData(reload)


            console.log 'reset'

            return
        ).fail (status) ->
            console.log 'error'
            return
        return

    resetDataNoSave = ->

        app_math().done((data) ->
            # console.table data
            object.css
              left: data.result.rel.x + "%"
              top: data.result.rel.y + "%"
              width: data.result.rel.width + "%"
              height: data.result.rel.height + "%"

            object.data 'x', data.result.rel.x
            object.data 'y', data.result.rel.y
            object.data 'width', data.result.rel.width
            object.data 'height', data.result.rel.height

            return
        ).fail (status) ->
            console.log 'error'
            return
        return

    checkPosition = (newX, newY) ->

        # obrazek nikdy nemuze opustit ramec 
        # text naopak musi zustat uvnitr, stejne jako shape
            
            # minX plus pravy bleed
            # maxX minus levy bleed

        # console.log object.data 'content_type'


        # spadavku musim definovat jako procenta z vysky a procenta ze sirky frameu
        if object.data('content_type') == 'photo'
            
            if parseFloat(object.data 'e_bleed') > 0
                e_bleed = frame.data('bleed_pct') / 100
            else e_bleed = 0
            
            if parseFloat(object.data 'w_bleed') > 0
                w_bleed = frame.data('bleed_pct') / 100
            else w_bleed = 0

            minX = (frame.outerWidth() - object.width()) + (e_bleed * frame.outerWidth())
            maxX = 0 - (frame.outerWidth() * w_bleed)

            if parseFloat(object.data 'n_bleed') > 0
                n_bleed = frame.data('bleed_pct') / 100
            else n_bleed = 0
            
            if parseFloat(object.data 's_bleed') > 0
                s_bleed = frame.data('bleed_pct') / 100
            else s_bleed = 0

            # minX plus horni bleed
            # maxX minus spodni bleed
            minY = (frame.outerHeight() - object.height()) + (frame.outerWidth() * s_bleed)
            maxY = 0 - (frame.outerWidth() * n_bleed)
        
        if object.data('content_type') == 'shape' || object.data('content_type') == 'text' || object.data('content_type') == 'html_text'
            minX = -15
            maxX = frame.outerWidth() - object.width() - 5
            minY = 5
            maxY = frame.outerHeight() - object.height() - 5
            console.log object.data('product_type')
            if object.hasClass('floating_photo') && object.data('product_type') != 'book'
                minX = 5
                maxX = frame.outerWidth() - object.width() - 5
                minY = 25
                maxY = frame.outerHeight() - object.height() - 70


        console.log minX, maxX, minY, maxY

        if newX > minX && newX < maxX 
            object.css 'left', newX
            object.data 'mouseX', event.clientX
        else 
            if newX <= minX
                object.css 'left', minX
                object.data 'mouseX', event.clientX
                newX = minX
            if newX >= maxX
                object.css 'left', maxX
                object.data 'mouseX', event.clientX
                newX = maxX

        if newY > minY && newY < maxY
            object.css 'top', newY
            object.data 'mouseY', event.clientY
            if newY <= minY
                object.css 'top', minY
                object.data 'mouseY', event.clientY
            if newY >= maxY
                object.css 'top', maxY
                object.data 'mouseY', event.clientY

        return {x: newX, y: newY}

    move = (event) ->

        if object.attr('resized') == 'true' && $('#page_detail').length

            event.preventDefault()
            event.stopPropagation()



            changeX = event.clientX - object.data('mouseX')
            changeY = event.clientY - object.data('mouseY')

            # ratio = parseFloat(object.data('height')) / parseFloat(object.data('width'))
            

            newWidth = parseFloat(object.css('width')) + (changeX)
            newHeight = newWidth * (parseFloat(object.data('ratio')) * (frame.data('frame_ratio') / 100))

            if object.data('content_type') == 'html_text'
                newHeight = parseFloat(object.css('height')) + (changeY)
                # newWidth = newHeight / (parseFloat(object.data('ratio')) * (frame.data('frame_ratio') / 100))


            # console.log (parseFloat(frame.width()) - parseFloat(object.css('left')))
            # console.log newWidth

            maxWidth = (parseFloat(frame.outerWidth()) - parseFloat(object.css('left')))
            maxHeight = (parseFloat(frame.outerHeight()) - parseFloat(object.css('top')))


            # console.log newWidth, newHeight, maxWidth, maxHeight
            # console.log maxWidth, maxHeight, 'MAXES'

            if object.hasClass('floating_photo') && object.data('product_type') != 'book'
                maxWidth = maxWidth
                maxHeight = maxHeight - (maxHeight * 0.10)
            if newWidth < maxWidth && newHeight < maxHeight
            

                object.css 'width', newWidth
                object.css 'height', newHeight
                object.data 'mouseX', event.clientX
                object.data 'mouseY', event.clientY


        if object.attr('dragged') == 'true' && $('#page_detail').length

            # u fotek s bilyma pruhama nejde hnout ani o pid
            if (parseInt(object.data('width')) < 100 || parseInt(object.data('height')) < 100) && object.data('content_type') == 'photo'
                return false

            event.preventDefault()
            event.stopPropagation()

            changeX = event.clientX - object.data('mouseX')
            changeY = event.clientY - object.data('mouseY')
            
            newX = parseFloat(object.css('left')) + changeX
            newY = parseFloat(object.css('top')) + changeY

            # jestli je uvnitr bleed_container
            checkedPosition = checkPosition(newX, newY)
         return

    recalc2relativeSize = ->

        newWidth = (parseFloat(object.css 'width') / parseFloat(frame.outerWidth())) * 100
        newHeight = (parseFloat(object.css 'height') / parseFloat(frame.outerHeight())) * 100
        object.css 'width', newWidth+"%"
        object.css 'height', newHeight+"%"
        object.data 'width' , newWidth
        object.data 'height' , newHeight

    recalc2relative = ->

        newX = (parseFloat(object.css 'left') / parseFloat(frame.outerWidth())) * 100
        newY = (parseFloat(object.css 'top') / parseFloat(frame.outerHeight())) * 100
        object.css 'left', newX+"%"
        object.css 'top', newY+"%"  
        object.data 'x' , newX
        object.data 'y' , newY

        
        

    saveData = (reload) ->

        $.ajax(
          dataType: 'JSON'
          method: 'POST'
          data:
            frame_id: frame.data 'frame_id'
            object_id: object.data 'object_id'
            content_type: object.data 'content_type'
            app_url: window.location.pathname
            width: object.data 'width'
            height: object.data 'height'
            x: object.data 'x' 
            y: object.data 'y' 
            zoom: object.data 'zoom' 
            angle: object.data 'angle' 

          url: '/ajax/app/save/'
        ).done((data) ->
            console.log data.frame_array
            if data.frame_array_length > 1
                $.each data.frame_array, (key, value) ->

                    $('.frame[data-frame_id='+key+']').html value.html
                    $('.frame[data-frame_id='+key+']').frameEvents({drop: true, clickable_drop: true})

            if reload
                loadPage()
            # output.init()
            console.log data
        ).fail (jqXHR, textStatus) ->
          console.warn 'Error: ' + jqXHR.responseText
          return
        return false  
    
    recalcFrameVars = ->
        # propocita a nahradi, x, y, minmilani a maximalni hodnoty
        return

    last_val = 0
    
    zoomInterval = null

    output = {
    
        init: () ->
            # console.log 'frame init> ' + frame.attr 'id'
            # 
            # 

            if object.data('content_type') == 'photo'
                frame.find('input[name=zoom]').change 'mousestop', ->
                    output.zoomRange $(@).val()

            if object.data('content_type') == 'photo'
                object.dblclick ->
                    output.reset()

            object.find('.ico.delete_object').click ->
                output.deleteObject()
                false

            frame.find('.ico.make_float').click ->
                console.log 'click na float', object
                output.makeFloat()
                return false

            if object.data('content_type') == 'photo'
                frame.find('.ico.rotate').click ->
                    output.rotate()
                    return false

            if object.data('content_type') == 'photo'
                frame.find('.ico.zoom_in').click ->
                    console.log 'zoom in'
                    output.zoom 'in'
                    return false


            if object.data('content_type') == 'photo'
                frame.find('.ico.zoom_out').click ->
                    output.zoom 'out'
                    return false


            if (settings.drop)
                frame.find('form').dropzone
                    maxFiles: 1
                    init: ->
                        this.on 'success', (file, out) ->
                            output.insert(file.name)
                            photoContainer = $('#photo_container').photoContainer()
                            return
                        return
                        this.on 'totaluploadprogress', (uploadProgress, totalBytes, totalBytesSent) ->
                            # console.log uploadProgress, totalBytes, totalBytesSent
                            return
                        return
                    
            return

        makeFloat: () ->
            
            $.ajax(
              dataType: 'JSON'
              method: 'POST'
              data:
                app_url: window.location.pathname
                frame_id: frame.data('frame_id')
                object_id: object.data('object_id')
              url: '/ajax/app/make_float/'
            ).done((data) ->
                loadPage()
                return
            ).fail (jqXHR, textStatus) ->
                console.warn 'Error: ' + jqXHR.responseText
                return
            return   

        deleteObject: () ->
            # inserted_photo = frame.append '<img src="/test_photos/c.jpg" />'
            # inserted_photo = frame.html('INSERTED ')
            # console.log frame.data('frame_id'), image_name, window.location.pathname
            object.remove()
            
            $.ajax(
              dataType: 'JSON'
              method: 'POST'
              data:
                app_url: window.location.pathname
                object_id: object.data('object_id')
                frame_id: frame.data('frame_id')
              url: '/ajax/app/delete_object/'
            ).done((data) ->
                # console.log data
                deactivateTexts()
                # textsContainer.reload()
                return
            ).fail (jqXHR, textStatus) ->
                console.warn 'Error: ' + jqXHR.responseText
                return
            return   

        insert: (image_name) ->
           
            $.ajax(
              dataType: 'JSON'
              method: 'POST'
              data:
                app_url: window.location.pathname
                photo: image_name
                frame_id: frame.data('frame_id')
              url: '/ajax/app/photo_insert/'
            ).done((data) ->

                # console.log data
                frame.html data.new_frame_html
                element = frame.find 'img'

                output.init()
                output.draggable()

                frame.removeClass 'empty'
                return
            ).fail (jqXHR, textStatus) ->
                console.warn 'Error: ' + jqXHR.responseText
                return
            return              

        rotate: ->
            showLoader()
            $.ajax(
              dataType: 'JSON'
              method: 'POST'
              data:
                app_url: window.location.pathname
                filename: object.find('img').attr 'src'
                frame_id: frame.data('frame_id')
              url: '/ajax/app/photo_rotate/'
            ).done((data) ->
                # console.log data
                frame.html data.new_frame_html.html
                element = frame.find 'img'
                resetData(true)
                hideLoader()
                # loadPage()

                return
            ).fail (jqXHR, textStatus) ->
                console.warn 'Error: ' + jqXHR.responseText
                return
            return      


        zoomJS: (zoom) ->

            zoom_val = object.data 'zoom'

            if zoom == 'in' && zoom_val < 200
                new_zoom = zoom_val + 1
            if zoom == 'out' && zoom_val > 0
                new_zoom = zoom_val - 1
    
            # console.log object.data('width'), object.data('height')                

            frame_ratio = frame.data('frame_width') / frame.data('frame_height')
            image_ratio = object.data('width') / object.data('height')

            console.log frame_ratio, image_ratio

            if (image_ratio > 1)
                # na sirku
                if image_ratio > frame_ratio
                    new_height = 100 + (new_zoom * 2) 
                    new_width = new_height * image_ratio
                else 
                    new_width = 100 + (new_zoom * 2) 
                    new_height = new_width * (1 / image_ratio)
                       
            else 
                # na vysku
                if image_ratio > frame_ratio
                    new_height = 100 + (new_zoom * 2) 
                    new_width = new_height * image_ratio
                else
                    new_width = 100 + (new_zoom * 2) 
                    new_height = new_width * (1 / image_ratio)
                


            # if object.data('width') > object.data('height')
            #     new_width = 100 + (new_zoom * 2)
            #     new_height = new_width * (1 / (object.data('width') / object.data('height')))
            # else
            #     new_width = 100 + (new_zoom * 2)
            #     new_height = new_width * (1 / (object.data('width') / object.data('height')))



            new_x = ((new_width - 100) / 2) * -1
            new_y = ((new_height - 100) / 2) * -1

            # console.log new_zoom, new_width, new_height, new_x, new_y

            object.data 'zoom', new_zoom
            object.data 'width', new_width
            object.data 'height', new_height
            object.data 'x', new_x
            object.data 'y', new_y
            object.css
              width: new_width + "%"
              height: new_height + "%"
              top: new_y + "%"
              left: new_x + "%"
            return
            

        zoom: (zoom) ->

            zoom_val = parseInt(object.data 'zoom')
            minimal_zoom = parseInt(frame.find('.ico.zoom_out').data('minimal_zoom'))

            console.log zoom_val

            if zoom == 'in' && zoom_val < 200
                zoom_val = zoom_val + 3


            if zoom == 'out' && zoom_val >= 3
                zoom_val = zoom_val - 3

            object.data 'zoom', zoom_val

            resetData()

            if zoom_val == 0 || zoom_val <= minimal_zoom
                frame.find('.ico.zoom_out').hide()
            else
                frame.find('.ico.zoom_out').show()
   
            frame.find('input[name=zoom]').val zoom_val

            

        zoomRange: (zoom) ->
            console.log zoom

            object.data 'zoom', zoom
            resetData()             
             

        reset: ->
            resetData(true)

        draggable: ->

            object.addTouch()

            $(document).mousemove(move)      
            
            object.find('.resizer').mousedown (event) ->
                console.log 'reisze'

            object.mousedown (event) ->               
                
                if $(event.target).hasClass 'resizer'
                    if !resized && $('#page_detail').length
                        resized = true 
                        object.attr 'resized', true
                        object.data 'mouseX', event.clientX
                        object.data 'mouseY', event.clientY 
                else
                    if !dragged && $('#page_detail').length
                        dragged = true 
                        $('#drag_helper').show()
                        object.data 'old-z', object.css 'z-index'
                        console.log object.data 'old-z'
                        # object.css 'z-index', 10000
                        object.attr 'dragged', true
                        object.addClass 'dragged'
                        object.data 'mouseX', event.clientX
                        object.data 'mouseY', event.clientY                            

            object.parents(':last').mouseup (event) ->
                if resized && $('#page_detail').length
                    resized = false
                    object.attr 'resized', false
                    recalc2relativeSize()   
                    saveData(false)

                if dragged && $('#page_detail').length
                    resized = false
                    dragged = false
                    # $('#drag_helper').hide()
                    # console.log object.data 'content_type'
                    object.removeClass 'dragged'
   
                    object.attr 'dragged', false
                    recalc2relative()   
                    saveData(false)
      

    }

    output.init()
    output.draggable()

    return output